"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const actions_1 = require("src/redux/actions");
const selectors_1 = require("src/redux/sagas/selectors");
const final_1 = __importDefault(require("src/components/final/final"));
const app_error_1 = __importDefault(require("src/components/app-error"));
const spinner_1 = __importDefault(require("src/components/spinner"));
const next_button_1 = __importDefault(require("src/components/buttons/next-button"));
const skip_button_1 = __importDefault(require("src/components/buttons/skip-button"));
const back_button_1 = __importDefault(require("src/components/buttons/back-button"));
const redirects_1 = require("src/hooks/redirects");
const frame_1 = require("src/utils/frame");
const webview_1 = require("src/utils/webview");
const survey_1 = require("src/utils/survey");
const modal_1 = require("src/context/modal");
const pages_styles_1 = __importDefault(require("./pages.styles"));
const b = b_1.default.with('pages');
const __page = b_1.default.with('page');
// eslint-disable-next-line complexity
const getErrorCode = ({ reason, status }) => {
    if (reason) {
        switch (reason) {
            case 'ALREADY_FINISHED':
                return 'surveyAlreadyFinished';
            case 'SURVEY_PAUSED':
                return 'surveyPaused';
            case 'SURVEY_CLOSED':
                return 'surveyClosed';
            case 'SURVEY_DOES_NOT_EXIST':
                return 'surveyNotFound';
            default:
                return 'serverDefault';
        }
    }
    else if (status && Number(status) !== 404) {
        return 'serverDefault';
    }
};
// eslint-disable-next-line max-statements, complexity
function Pages(props) {
    const { status = 202, mix = '', theme = 'default', page = null, reason, inited, isFinished, retpath, isNextButtonEnabled, enableVendorLabel, buttonTheme, buttonNextSize, isShowSkipButton, isPollStarted, pageNumber, PageComponent, isCurrentPageUxAnswered, surveyPreset } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const inFrame = (0, frame_1.isInIframe)();
    const inWebview = (0, webview_1.isInWebview)();
    (0, redirects_1.useFinishRedirect)({ status, isFinished, retpath });
    (0, react_2.useEffect)(() => {
        dispatch((0, actions_1.pageSwitched)(pageNumber));
    }, [dispatch, pageNumber]);
    const { feedbackDemoMode } = (0, modal_1.useModalContext)();
    const classes = `${b({
        preset: surveyPreset,
        isFeedback: (0, survey_1.isFeedback)(),
        noFeedbackDemo: !feedbackDemoMode
    })}${mix}`;
    function renderVendorLabel() {
        if (!enableVendorLabel) {
            return null;
        }
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: __page('vendor-label') }, { children: [(0, jsx_runtime_1.jsx)("span", { children: 'Опрос проводится на\u00a0технологиях ' }), (0, jsx_runtime_1.jsx)("a", Object.assign({ href: 'https://surveys.yandex.ru/?utm_source=videosurvey', target: '_blank', rel: 'noopener noreferrer' }, { children: "\u042F\u043D\u0434\u0435\u043A\u0441.\u0412\u0437\u0433\u043B\u044F\u0434\u0430" }))] })));
    }
    const [isTimeoutFired, setIsTimeoutFired] = (0, react_2.useState)(false);
    (0, react_2.useEffect)(() => {
        if (isShowSkipButton) {
            setTimeout(() => {
                setIsTimeoutFired(true);
            }, 5000);
        }
    }, [pageNumber, isShowSkipButton]);
    // eslint-disable-next-line max-statements
    const _a = (0, react_redux_1.useSelector)((state) => {
        const { questions, widgets, groups, lang, survey: { charLimits } } = state;
        // eslint-disable-next-line no-shadow
        const pageNumber = (0, selectors_1.getCurrentPage)(state);
        const { search } = (0, selectors_1.getLocation)(state);
        const pagesList = (0, selectors_1.getPages)(state);
        const conditions = (0, selectors_1.getSurveyConditions)(state);
        const nextPageIndex = (0, selectors_1.getNextPageIndex)({ pagesList, currPageIndex: pageNumber, conditions });
        // eslint-disable-next-line no-shadow
        const prevPageIndex = (0, selectors_1.getPreviousPageIndex)({ pagesList, currPageIndex: pageNumber });
        // eslint-disable-next-line no-shadow
        const isPreviousScreening = (0, selectors_1.isPreviousPageScreening)({ pagesList, currPageIndex: pageNumber });
        const { displayMode, header, embedded } = (0, selectors_1.getConfig)(state);
        // eslint-disable-next-line no-shadow
        const isCurrentPageUxAnswered = (0, selectors_1.getCurrentPageUxAnswered)(state);
        return {
            charLimits,
            pageNumber,
            questions,
            widgets,
            groups,
            lang,
            search,
            displayMode,
            nextPageIndex,
            prevPageIndex,
            isCurrentPageUxAnswered,
            isDemoModeWithHeader: header.enable && state.survey.demoMode,
            isEmbedded: embedded,
            isPreviousScreening
        };
    }), { prevPageIndex, isPreviousScreening } = _a, pageProps = __rest(_a, ["prevPageIndex", "isPreviousScreening"]);
    const renderNextButton = (0, react_2.useCallback)(
    // eslint-disable-next-line complexity, max-statements
    ({ label }) => {
        var _a;
        if (theme === 'ux' && !isCurrentPageUxAnswered) {
            return null;
        }
        let BtnComponent = ((0, jsx_runtime_1.jsx)(next_button_1.default, { size: buttonNextSize, view: buttonTheme, disabled: !isNextButtonEnabled, label: label }));
        let BackBtnComponent = null;
        if (prevPageIndex !== -1 && !isPreviousScreening && ((_a = page === null || page === void 0 ? void 0 : page.backBtn) === null || _a === void 0 ? void 0 : _a.enabled)) {
            BackBtnComponent = ((0, jsx_runtime_1.jsx)(back_button_1.default, { size: buttonNextSize, view: buttonTheme, label: page.backBtn.label }));
        }
        if (isShowSkipButton && !isPollStarted) {
            if (isTimeoutFired) {
                BtnComponent = ((0, jsx_runtime_1.jsx)(skip_button_1.default, { size: buttonNextSize, disabled: !isNextButtonEnabled }));
            }
            else if (!isTimeoutFired) {
                BtnComponent = null;
            }
        }
        return ((0, jsx_runtime_1.jsxs)("aside", Object.assign({ className: __page('button') }, { children: [BackBtnComponent, BtnComponent] })));
    }, [
        theme,
        isCurrentPageUxAnswered,
        isPreviousScreening,
        buttonNextSize,
        buttonTheme,
        isNextButtonEnabled,
        page === null || page === void 0 ? void 0 : page.backBtn,
        isShowSkipButton,
        isPollStarted,
        isTimeoutFired,
        prevPageIndex
    ]);
    let Component;
    let errorCode;
    if (status === 302 && (inFrame || inWebview)) {
        Component = (0, jsx_runtime_1.jsx)(final_1.default, { theme: theme });
    }
    else if ([202, 302].includes(status)) {
        Component = (0, jsx_runtime_1.jsx)(spinner_1.default, {});
    }
    else if (status === 200) {
        if (page) {
            const props = Object.assign(Object.assign(Object.assign({ theme }, page), pageProps), { renderVendorLabel,
                renderNextButton });
            Component = (0, jsx_runtime_1.jsx)(PageComponent, Object.assign({}, props));
        }
        else {
            Component = (0, jsx_runtime_1.jsx)(final_1.default, { theme: theme });
        }
    }
    else {
        errorCode = getErrorCode({ reason, status });
        Component = (0, jsx_runtime_1.jsx)(app_error_1.default, { status: status, reason: reason, inited: inited });
    }
    (0, redirects_1.useErrorRedirect)(errorCode);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: pages_styles_1.default }), Component] })));
}
exports.default = Pages;
